import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import { get, post, put } from '../../../inteceptor';
import moment from 'moment';

const initialState = {
  error: null,
  time: null,
  data: [],
  addData: {},
  sorted: [],
};

const slice = createSlice({
  name: 'productCategories',
  initialState,
  reducers: {
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    getProductCategoriesSuccess(state, action) {
      state.data = action.payload.data;
    },

    addOrUpdateProductCategories(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },

    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },

    onNextStep(state) {
      state.checkout.activeStep += 1;
    },

    onGotoStep(state, action) {
      const goToStep = action.payload;
      state.checkout.activeStep = goToStep;
    },
  },
});

export default slice.reducer;

export const { filterCategories } = slice.actions;

export function getProductCategories() {
  return async () => {
    try {
      const response = await get(`product-category`);
      if (response.status) {
        dispatch(slice.actions.getProductCategoriesSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function addProductCategories(body) {
  return async () => {
    try {
      const response = await post(`product-category`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateProductCategories(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateProductCategories(body) {
  return async () => {
    try {
      const response = await put(`product-category/${body?.id}`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateProductCategories(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
